import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"
import _imports_0 from 'assets/images/promo/betsoft.svg'
import _imports_1 from 'assets/images/promo/bigtimegaming.svg'
import _imports_2 from 'assets/images/promo/blablabla.svg'
import _imports_3 from 'assets/images/promo/betgamestv.svg'
import _imports_4 from 'assets/images/promo/irondogstudio.svg'
import _imports_5 from 'assets/images/promo/amatic.svg'
import _imports_6 from 'assets/images/promo/authentic.svg'
import _imports_7 from 'assets/images/promo/ainsworth.svg'
import _imports_8 from 'assets/images/promo/2by2.svg'
import _imports_9 from 'assets/images/promo/1x2gaming.svg'
import _imports_10 from 'assets/images/promo/fantasma.svg'
import _imports_11 from 'assets/images/promo/neteller.svg'
import _imports_12 from 'assets/images/promo/instadebit.svg'
import _imports_13 from 'assets/images/promo/interac.svg'
import _imports_14 from 'assets/images/promo/russiancards.svg'
import _imports_15 from 'assets/images/promo/CoinsPaid_white.svg'
import _imports_16 from 'assets/images/promo/etransfer-white.svg'
import _imports_17 from 'assets/images/promo/visa.svg'
import _imports_18 from 'assets/images/promo/Mastercard_White.svg'
import _imports_19 from 'assets/images/promo/maestro.svg'
import _imports_20 from 'assets/images/promo/yandex.svg'
import _imports_21 from 'assets/images/promo/skrill.svg'
import _imports_22 from 'assets/images/promo/ecopayz.svg'
import _imports_23 from 'assets/images/promo/idebit.svg'
import _imports_24 from 'assets/images/promo/neosurf.svg'
import _imports_25 from 'assets/images/promo/paysafecard.svg'
import _imports_26 from 'assets/images/promo/rapid-transfer.svg'
import _imports_27 from 'assets/images/promo/alfaclick.svg'
import _imports_28 from 'assets/images/promo/copyright.png'


const _hoisted_1 = ["data-theme"]
const _hoisted_2 = {
  key: 0,
  autoplay: "",
  playsinline: "",
  loop: "",
  muted: "",
  preload: "auto",
  class: "modern-video-background"
}
const _hoisted_3 = ["src", "type"]
const _hoisted_4 = { class: "modern-head" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "modern-head-content" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "modern-custom-button-text" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "modern-custom-button-svg",
  version: "1.1",
  id: "Слой_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 382 110",
  style: {"enable-background":"new 0 0 382 110"},
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "st0",
    d: "M16.1,22.9C18.3,13.7,26.5,7.1,35.9,7l301.9-4.5c8-0.1,15.3,4.3,18.8,11.5l22.8,45.9c6.6,13.3-2.5,29.1-17.4,29.9L23.3,108c-13.8,0.7-24.4-12-21.3-25.4L16.1,22.9z",
    fill: "#B317FC"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "modern-custom-button-hover",
  x: "0px",
  y: "0px",
  viewBox: "0 0 390 120",
  style: {"enable-background":"new 0 0 390 120"},
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "st0",
    d: "M16.6,25.4C18.9,14.7,30.5,6.7,44.2,6.5l292.3-4.8c12.2-0.2,23.3,5.8,27.4,15l23.4,51.9c6.4,14.1-5.9,29.2-24.7,30.3L32.6,118.6c-18.5,1.1-33.3-11.9-30.2-26.5L16.6,25.4z",
    fill: "none",
    stroke: "#B317FC"
  })
], -1)
const _hoisted_11 = { class: "modern-stepe-container" }
const _hoisted_12 = { class: "modern-steper" }
const _hoisted_13 = { class: "modern-steper__block" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "modern-steper__number" }, "1.", -1)
const _hoisted_15 = { class: "modern-steper__block" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "modern-steper__number" }, "2.", -1)
const _hoisted_17 = { class: "modern-steper__block" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "modern-steper__number" }, "3.", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "modern-supplied" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_0,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_1,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_2,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_3,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_4,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_5,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_6,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_7,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_8,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_9,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_10,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_11,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_12,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_13,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_14,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_15,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_16,
      alt: "img"
    })
  ])
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "modern-supplied modern-supplied__bottom" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_17,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_18,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_19,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_20,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_21,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_22,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_23,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_24,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_25,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_26,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_27,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_11,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_12,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_13,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_14,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_15,
      alt: "img"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "modern-supplied__img",
      src: _imports_16,
      alt: "img"
    })
  ])
], -1)
const _hoisted_21 = { class: "modern-footer" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  class: "modern-footer__img",
  src: _imports_28,
  alt: "copyright"
}, null, -1)
const _hoisted_23 = { class: "modern-footer__copyright" }

import { computed, onMounted, ref, toRefs, watch } from 'vue';
import { useCommonPromo } from '@/composables/useCommonPromo';
import Markdown from '@/components/markdown.vue';
import usePromoModal from '@/composables/promoModalState';
import { RegFormInterface } from '~/types/regForm.interface';
import { PromoPageInterface } from '~/types/promoPage.interface';
import { useStore } from 'vuex';
import PromoModals from '@/components/promoModals.vue';
import { CurrencyMenuItemParsedInterface } from '@/types/currencyMenu.interface';


export default /*#__PURE__*/_defineComponent({
  props: {
    pageData: null
  },
  setup(__props: any) {

const props = __props as {
  pageData: PromoPageInterface;
}



const selectedCurrency = ref('');

const onChangeCurrency = (newCurrency: string) => {
  selectedCurrency.value = newCurrency;
};

const {
  dataPlatformAttr,
  theme,
  videoBanner,
  logoImg,
  secondTitle,
  currency,
  bannerCssVariables,
  lang,
} = useCommonPromo(props, selectedCurrency);

const store = useStore();

onMounted(() => {
  store.dispatch('profileForm/load', lang.value);
});

const userCountry = computed((): string => store.getters['country/country']);

const currencies = computed(
  (): CurrencyMenuItemParsedInterface[] =>
    store.getters['currencyMenu/activeCurrencies']
);

const activeCurrencies = computed((): CurrencyMenuItemParsedInterface[] => {
  if (!userCountry.value || props.pageData.params[0].only_crypto) {
    return currencies.value.filter(({ crypto }) => !!crypto);
  }

  return currencies.value.filter(
    ({ exluded_countries }) =>
      !exluded_countries.length ||
      !exluded_countries.some((country) => country === userCountry.value)
  );
});

const loadLocalizedUserData = () => {
  if (userCountry.value) {
    if (Array.isArray(props?.pageData?.params[0]?.second_title_multi)) {
      const titleForCountry = props.pageData.params[0].second_title_multi.find(
        (c) => c.country === userCountry.value
      );
      if (titleForCountry) {
        selectedCurrency.value = titleForCountry.currency;
        return;
      }
    }
    const defaultCurrencyForCountry = activeCurrencies.value.find((currency) =>
      currency.default_for_countries.some(
        (country) => country === userCountry.value
      )
    );

    if (currency.value) {
      selectedCurrency.value = currency.value;
    } else if (defaultCurrencyForCountry?.currency_code) {
      selectedCurrency.value = defaultCurrencyForCountry.currency_code;
    } else {
      selectedCurrency.value = activeCurrencies.value[0]?.currency_code;
    }
  }
};

watch(() => currencies.value, loadLocalizedUserData, { immediate: true });

const { openModal } = usePromoModal();

const isPlayerAuthorised = computed(
  (): boolean => store.getters['ssPlayer/isPlayerAuthorised']
);

const redirectHost = computed(() => store.getters['systemHosts/redirectHost']);

function registerHandler() {
  if (isPlayerAuthorised.value) {
    window.location.href = `https://${redirectHost.value}`;
  } else {
    openModal();
  }
}

const regForm = computed(
  (): RegFormInterface => store.getters['regForm/formData']
);

const {
  first_title: firstTitle,
  third_title: thirdTitle,
  footer_text: footerText,
  copyright_text: copyrightText,
  first_step: firstStep,
  second_step: secondStep,
  third_step: thirdStep,
  form_button_text: formBtnText,
} = toRefs(props.pageData.params[0]);

const registerTitle = computed((): string => {
  return formBtnText.value || regForm.value.register_button_title;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PromoModals, {
      lang: _unref(lang),
      pageData: __props.pageData,
      selectedCurrency: selectedCurrency.value,
      onChangeCurrency: onChangeCurrency
    }, null, 8, ["lang", "pageData", "selectedCurrency"]),
    (__props.pageData)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modern-container",
          "data-theme": _unref(theme)
        }, [
          _createElementVNode("div", _mergeProps({ class: "modern-wrapper" }, _unref(dataPlatformAttr), { style: _unref(bannerCssVariables) }), [
            (_unref(videoBanner))
              ? (_openBlock(), _createElementBlock("video", _hoisted_2, [
                  _createElementVNode("source", {
                    src: _unref(videoBanner).url,
                    type: _unref(videoBanner).mime
                  }, null, 8, _hoisted_3)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              (_unref(logoImg))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "modern-head__img",
                    src: _unref(logoImg).url,
                    alt: "7bit-logo"
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(Markdown, {
                  "auto-link-parse": false,
                  text: _unref(firstTitle),
                  class: "modern-head__title-top"
                }, null, 8, ["text"]),
                _createVNode(Markdown, {
                  "auto-link-parse": false,
                  text: _unref(secondTitle),
                  class: "modern-head__title"
                }, null, 8, ["text"]),
                _createVNode(Markdown, {
                  "auto-link-parse": false,
                  text: _unref(thirdTitle),
                  class: "modern-head__text"
                }, null, 8, ["text"]),
                _createElementVNode("div", {
                  class: "modern-custom-button",
                  onClick: _withModifiers(registerHandler, ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(registerTitle)), 1),
                  _hoisted_9,
                  _hoisted_10
                ], 8, _hoisted_7)
              ])
            ])
          ], 16),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(Markdown, {
                  "auto-link-parse": false,
                  text: _unref(firstStep),
                  class: "modern-steper__center"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(Markdown, {
                  "auto-link-parse": false,
                  text: _unref(secondStep),
                  class: "modern-steper__center"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(Markdown, {
                  "auto-link-parse": false,
                  text: _unref(thirdStep),
                  class: "modern-steper__center"
                }, null, 8, ["text"])
              ])
            ])
          ]),
          _hoisted_19,
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createVNode(Markdown, {
                "auto-link-parse": false,
                text: _unref(footerText)
              }, null, 8, ["text"]),
              _createVNode(Markdown, {
                "auto-link-parse": false,
                text: _unref(copyrightText),
                class: "modern-footer__copyright"
              }, null, 8, ["text"])
            ])
          ])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})